import React from 'react';
import VersusTooltip from './VersusTooltip';

/**
 * Renderiza el bloque VersusChart de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function VersusChart({
  v
}) {
  return React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.296296vh 1.666667vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.111111vh",
      "minHeight": "0",
      "minWidth": "0"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.296296vh"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh",
      "flex": "1",
      "minWidth": "0"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.388889vh",
      "fontWeight": "600"
    }
  }, v.text("Comparación")), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vsMetCount))), React.createElement("button", {
    "onClick": v.vsMetAll,
    style: {
      "height": "2.407407vh",
      "padding": "0 0.925926vh",
      "border": "0.092593vh solid rgba(46,179,238,0.22)",
      "borderRadius": "0.555556vh",
      "background": "transparent",
      "color": "oklch(0.78 0.11 220)",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "opacity": v.vsMetAllOp,
      "display": v.vsShowMetAll ? "block" : "none",
      "whiteSpace": "nowrap"
    }
  }, v.text("Todas")), v.vsRadarToggle ? React.createElement("button", {
    "onClick": v.vsRadarToggle.onClick,
    "aria-pressed": v.vsRadarToggle.pressed,
    style: {
      "height": "2.407407vh",
      "padding": "0 0.925926vh",
      "border": "0.092593vh solid oklch(0.66 0.19 42)",
      "borderRadius": "0.555556vh",
      "background": v.vsRadarToggle.pressed ? "rgba(232,78,14,0.14)" : "transparent",
      "color": "#e4e9f0",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vsRadarToggle.label)) : null, React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.vsPers || []).map((m, index116) => React.createElement(React.Fragment, {
    key: index116
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.833333vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label)))))), v.text("\n      "), React.createElement("div", {
    "onMouseLeave": v.vsLeave,
    style: {
      "display": "grid",
      "gridTemplateColumns": "5vw repeat(5,minmax(0,1fr))",
      "gap": "0",
      "borderRadius": "0.740741vh",
      "overflow": "hidden",
      "background": "rgba(3,10,22,0.45)",
      "border": "0.092593vh solid rgba(46,179,238,0.1)"
    }
  }, React.createElement("span", {
    style: {
      "padding": "0.740741vh 0.925926vh 0.648148vh",
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "color": v.vsTFirstC,
      "whiteSpace": "nowrap",
      "display": "flex",
      "alignItems": "flex-end",
      "borderBottom": "0.185185vh solid rgba(46,179,238,0.1)"
    }
  }, v.text(v.vsTFirst)), (v.vsTHead || []).map((h, index117) => React.createElement(React.Fragment, {
    key: index117
  }, React.createElement("button", {
    "onClick": h.onClick,
    "title": h.title,
    style: {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "flex-end",
      "justifyContent": "flex-end",
      "gap": "0.462963vh",
      "padding": "0.740741vh 0.740741vh 0.648148vh",
      "border": "0",
      "borderBottom": "0.185185vh solid " + h.bd,
      "background": h.bg,
      "cursor": "pointer",
      "textAlign": "right",
      "minWidth": "0"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "1.111111vh",
      "borderRadius": "0.277778vh",
      "border": "0.138889vh solid " + h.dc,
      "background": h.dot,
      "color": "#0a1424",
      "font": "700 0.833333vh sans-serif",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "boxSizing": "border-box"
    }
  }, v.text(h.tick))), React.createElement("span", {
    style: {
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "color": h.c,
      "lineHeight": "1.25",
      "textWrap": "balance"
    }
  }, v.text(h.l))))), (v.vsTable || []).map((row, index118) => React.createElement(React.Fragment, {
    key: index118
  }, React.createElement("span", {
    "onMouseEnter": row.enter,
    style: {
      "padding": "0.555556vh 0.925926vh",
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": row.c,
      "borderTop": "0.092593vh solid rgba(46,179,238,0.07)",
      "background": row.bg,
      "cursor": "default"
    }
  }, v.text(row.n)), (row.cells || []).map((x, index119) => React.createElement(React.Fragment, {
    key: index119
  }, React.createElement("span", {
    "onMouseEnter": x.enter,
    style: {
      "padding": "0.555556vh 0.555556vh",
      "font": "1.203704vh 'IBM Plex Mono',monospace",
      "color": x.c,
      "textAlign": "right",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.07)",
      "whiteSpace": "nowrap",
      "background": x.bg
    }
  }, v.text(x.v))))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "center",
      "gap": "2.592593vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.1)"
    }
  }, (v.vsTabs || []).map((m, index120) => React.createElement(React.Fragment, {
    key: index120
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "background": "transparent",
      "padding": "0.555556vh 1.296296vh 0.740741vh",
      "cursor": "pointer",
      "font": "600 1.574074vh 'IBM Plex Sans',sans-serif",
      "color": m.color,
      "borderBottom": "0.185185vh solid " + m.bd,
      "marginBottom": "-0.092593vh"
    }
  }, v.text(m.label))))), v.text("\n      "), React.createElement("div", {
    style: {
      "height": v.vsTipHeight,
      "flex": "none",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center"
    }
  }, v.text("\n        "), v.vsNoTip ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "textAlign": "center"
    }
  }, v.text(v.vsInfo))) : null, v.text("\n        "), v.vsTip.on ? React.createElement(VersusTooltip, {
    tip: v.vsTip,
    text: v.text
  }) : null, v.text("\n      ")), v.text("\n      "), React.createElement("div", {
    "onMouseLeave": v.vsLeave,
    style: {
      "flex": "1",
      "minHeight": "0",
      "position": "relative"
    }
  }, v.text("\n        "), v.vsIsArea ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "height": "100%",
      "aspectRatio": "600 / 550",
      "maxWidth": "100%",
      "margin": "0 auto",
      "position": "relative"
    }
  }, React.createElement("svg", {
    "viewBox": "-300 -275 600 550",
    style: {
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, (v.vsGrid || []).map((g, index122) => React.createElement(React.Fragment, {
    key: index122
  }, React.createElement("circle", {
    "cx": "0",
    "cy": "0",
    "r": g.r,
    "fill": "none",
    "stroke": "rgba(135,147,166,0.16)"
  }, null))), (v.vsWedges || []).map((w, index123) => React.createElement(React.Fragment, {
    key: index123
  }, React.createElement("path", {
    "d": w.d,
    "fill": w.fill,
    "fillOpacity": w.op,
    "stroke": "rgba(10,20,36,0.9)",
    "strokeWidth": "1",
    "onMouseEnter": w.enter,
    style: {
      "cursor": "pointer"
    }
  }, null))), (v.vsRims || []).map((m, index124) => React.createElement(React.Fragment, {
    key: index124
  }, React.createElement("path", {
    "d": m.d,
    "stroke": m.c,
    "strokeWidth": "5",
    "fill": "none",
    "strokeLinecap": "round"
  }, null)))), (v.vsRims || []).map((m, index125) => React.createElement(React.Fragment, {
    key: index125
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": m.L,
      "top": m.T,
      "transform": m.tx,
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": m.c,
      "whiteSpace": "nowrap",
      "pointerEvents": "none"
    }
  }, v.text(m.n)))))) : null, v.text("\n        "), v.vsIsRadar ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "height": "100%",
      "aspectRatio": "600 / 550",
      "maxWidth": "100%",
      "margin": "0 auto",
      "position": "relative"
    }
  }, React.createElement("svg", {
    "viewBox": "-300 -275 600 550",
    style: {
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, (v.vsRGrid || []).map((g, index126) => React.createElement(React.Fragment, {
    key: index126
  }, React.createElement("path", {
    "d": g.d,
    "fill": "none",
    "stroke": "rgba(135,147,166,0.18)"
  }, null))), (v.vsAxes || []).map((a, index127) => React.createElement(React.Fragment, {
    key: index127
  }, React.createElement("path", {
    "d": a.d,
    "stroke": "rgba(135,147,166,0.22)"
  }, null))), (v.vsPolys || []).map((p, index128) => React.createElement(React.Fragment, {
    key: index128
  }, React.createElement("path", {
    "d": p.d,
    "fill": p.c,
    "fillOpacity": p.fo,
    "stroke": p.c,
    "strokeOpacity": p.so,
    "strokeWidth": "2.5",
    "strokeLinejoin": "round",
    "onMouseEnter": p.enter,
    style: {
      "cursor": "pointer"
    }
  }, null), (p.dots || []).map((d, index129) => React.createElement(React.Fragment, {
    key: index129
  }, React.createElement("circle", {
    "cx": d.x,
    "cy": d.y,
    "r": "4",
    "fill": p.c,
    "fillOpacity": p.so,
    "stroke": "#0a1424",
    "strokeWidth": "1.5",
    "onMouseEnter": d.enter,
    style: {
      "cursor": d.enter ? "pointer" : "default"
    }
  }, null)))))), (v.vsAxes || []).map((a, index130) => React.createElement(React.Fragment, {
    key: index130
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": a.L,
      "top": a.T,
      "transform": a.tx,
      "font": "600 1.111111vh 'IBM Plex Sans',sans-serif",
      "color": a.c,
      "whiteSpace": "nowrap",
      "pointerEvents": "none"
    }
  }, v.text(a.l)))))) : null, v.text("\n        "), v.vsRadarMsg ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "inset": "0",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "fontSize": "1.203704vh",
      "color": "#8793a6"
    }
  }, v.text("Selecciona al menos 3 métricas para el radar"))) : null, v.text("\n        "), v.vsIsAdv ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "height": "100%",
      "aspectRatio": "600 / 550",
      "maxWidth": "100%",
      "margin": "0 auto",
      "position": "relative"
    }
  }, React.createElement("svg", {
    "viewBox": "-300 -275 600 550",
    style: {
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, React.createElement("circle", {
    "cx": "0",
    "cy": "0",
    "r": "246",
    "fill": "rgba(20,16,44,0.55)"
  }, null), (v.vsGuides || []).map((g, index131) => React.createElement(React.Fragment, {
    key: index131
  }, React.createElement("circle", {
    "cx": "0",
    "cy": "0",
    "r": g.r,
    "fill": "none",
    "stroke": "rgba(184,193,206,0.14)",
    "strokeDasharray": "2 4"
  }, null))), (v.vsSfrBars || []).map((b, index132) => React.createElement(React.Fragment, {
    key: index132
  }, React.createElement("path", {
    "d": b.d,
    "stroke": b.c,
    "strokeWidth": "3",
    "opacity": "0.75"
  }, null))), React.createElement("path", {
    "d": v.vsHovLine,
    "stroke": "rgba(228,233,240,0.35)",
    "strokeWidth": "1"
  }, null), (v.vsDots || []).map((d, index133) => React.createElement(React.Fragment, {
    key: index133
  }, React.createElement("circle", {
    "cx": d.x,
    "cy": d.y,
    "r": d.r,
    "fill": d.f,
    "fillOpacity": d.op,
    "stroke": d.s,
    "strokeWidth": "1.2",
    style: {
      "pointerEvents": "none"
    }
  }, null))), (v.vsHits || []).map((h, index134) => React.createElement(React.Fragment, {
    key: index134
  }, React.createElement("path", {
    "d": h.d,
    "fill": "transparent",
    "onMouseEnter": h.enter
  }, null))), React.createElement("circle", {
    "cx": "0",
    "cy": "0",
    "r": v.vsCoreR,
    "fill": "rgba(34,30,66,0.95)",
    "stroke": "rgba(46,179,238,0.2)"
  }, null), (v.vsRims || []).map((m, index135) => React.createElement(React.Fragment, {
    key: index135
  }, React.createElement("path", {
    "d": m.d,
    "stroke": m.c,
    "strokeWidth": "5",
    "fill": "none",
    "strokeLinecap": "round"
  }, null)))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "50%",
      "top": "50%",
      "transform": "translate(-50%,-50%)",
      "width": "28%",
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "center",
      "gap": "0.277778vh",
      "textAlign": "center",
      "pointerEvents": "none"
    }
  }, (v.vsCore || []).map((l, index136) => React.createElement(React.Fragment, {
    key: index136
  }, React.createElement("span", {
    style: {
      "font": l.w + " " + l.s + "px 'IBM Plex Sans',sans-serif",
      "color": l.c,
      "whiteSpace": "nowrap",
      "marginTop": l.mt
    }
  }, v.text(l.t))))), (v.vsRims || []).map((m, index137) => React.createElement(React.Fragment, {
    key: index137
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": m.L,
      "top": m.T,
      "transform": m.tx,
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": m.c,
      "whiteSpace": "nowrap",
      "pointerEvents": "none"
    }
  }, v.text(m.n)))))) : null, v.text("\n      ")), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "center",
      "flexWrap": "wrap",
      "gap": "0.555556vh 1.481481vh",
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, v.text(v.vsFoot)), v.text("\n    "));
}
